import "./contact.css";
import {MdOutlineEmail} from 'react-icons/md'
import React, { useRef } from 'react';
import emailjs from 'emailjs-com'


const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ocy6k9m', 'template_r8fayw8', form.current, '1BCDTKN1dP5eY1ACd')

      e.target.reset()
  };
  return (
    <section id='contact'>
      <br/>
      <h2>Contact Me</h2>

      <div className='container contact_container'>
        <div className='contact_options'>
          <article className='contact_option'>
            <MdOutlineEmail className='contact_option-icon'/>
          <h4>Email</h4>
          <h5>monzon_hazel@yahoo.com</h5>
          <a href="mailto:monzon_hazel@yahoo.com" target="_blank">Send a message</a>
          </article>
        </div>
        {/*End of contact options*/}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder='Your Full Name' required></input>
          <input type="email" name="email" placeholder='Your Email' required></input>
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type="submit" className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact